/* global rp$, window */
import './hero.scss';
import debounce from 'lodash/debounce';

const getOwlCarousel = () => import(/* webpackChunkName: "get-owl-carousel" */ 'owl.carousel');

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Hero Module
	 * -----------------------------------------
	 * @section hero_js
	 ********************************************/
	(function HeroModule() {
		$onReady({
			rp$, window,
			label: 'hero',
			fn: function () {
				
				const $heroModules = rp$('.hero-module');
				rp$.each($heroModules, function HeroIterator(idx, heroModuleEle) {
					const $heroModuleEle = rp$(heroModuleEle);

					const $contentSlider = $heroModuleEle.find('.hero-content');
					const contentConfigBase64 = $contentSlider.attr('data-slider-config') || '';
					const contentConfigDecoded = contentConfigBase64 ? atob(contentConfigBase64) : '';

					const $imageSlider = $heroModuleEle.find('.hero-images');
					const imageConfigBase64 = $imageSlider.attr('data-slider-config') || '';
					const imageConfigDecoded = imageConfigBase64 ? atob(imageConfigBase64) : '';

					// Pull behavior options from data-attributes
					const transitionType = ($imageSlider.attr('data-transition-style') || '').toLowerCase();
					const timeoutFromHtml = parseInt($imageSlider.attr('data-timeout'), 10) || 5000;
					const showArrows = ($imageSlider.attr('data-show-arrows') || '').toString() === '1';
					const showDots = ($imageSlider.attr('data-show-dots') || '').toString() === '1';

					// Base config shared
					const baseConfig = {
						items: 1,
						loop: true,
						slideBy: 1,
						nav: showArrows,
						dots: showDots,
						smartSpeed: 600,
						autoplayHoverPause: true,
						mouseDrag: false,
						touchDrag: true,
						navText: [
							'<i class="fa fa-angle-left" aria-hidden="true"></i>',
							'<i class="fa fa-angle-right" aria-hidden="true"></i>'
						]
					};
					// Set Image Config
					let imageConfig = {
						...baseConfig,
						dots: showDots,
						nav: showArrows,
						autoplay: true,
						autoplayTimeout: timeoutFromHtml * 1000
					};

					// Content slider config
					let contentConfig = {
						...baseConfig,
						dots: showDots,
						nav: showArrows,
						autoplay: false,
						autoplayTimeout: timeoutFromHtml * 1000
					};

					// Apply fade animation if requested
					if (transitionType === 'fade') {
						imageConfig.animateIn = 'fadeIn';
						imageConfig.animateOut = 'fadeOut';
						contentConfig.animateIn = 'fadeIn';
						contentConfig.animateOut = 'fadeOut';
					}

					// Merge JSON configs
					if (contentConfigDecoded) {
						try { contentConfig = { ...contentConfig, ...JSON.parse(contentConfigDecoded) }; }
						catch (e) { console.log('Error parsing content config', e); }
					}
					if (imageConfigDecoded) {
						try { imageConfig = { ...imageConfig, ...JSON.parse(imageConfigDecoded) }; }
						catch (e) { console.log('Error parsing image config', e); }
					}

					// Force sync timeout between sliders
					const timeout = imageConfig.autoplayTimeout || contentConfig.autoplayTimeout || 5000;
					imageConfig.autoplayTimeout = timeout;
					contentConfig.autoplayTimeout = timeout;

					// Initialize Sliders when window is loaded
					window.onload = () => {
						if (!$contentSlider.length || !$imageSlider.length) return;

						getOwlCarousel().then(() => {
							let syncing = false;
							const syncTo = (from, to, index, speed = baseConfig.smartSpeed) => {
								if (syncing) return;
								syncing = true;
								to.trigger('to.owl.carousel', [index, speed, true])
									.one('translated.owl.carousel', () => { syncing = false; });
							};

							// Init content slider
							const contentOwl = $contentSlider
								.addClass('owl-carousel')
								.on('initialized.owl.carousel', () => {
									$contentSlider.trigger('to.owl.carousel', [0, 0, true]);
								})
								.owlCarousel(contentConfig);

							// Init image slider
							const imageOwl = $imageSlider
								.addClass('owl-carousel')
								.on('initialized.owl.carousel', () => {
									$imageSlider.trigger('to.owl.carousel', [0, 0, true]);
								})
								.owlCarousel(imageConfig);

							// Sync content to image changes
							imageOwl.on('changed.owl.carousel', e => {
								const index = e.item.index - e.relatedTarget._clones.length / 2;
								const slideIndex = (index + e.item.count) % e.item.count;
								syncTo(imageOwl, $contentSlider, slideIndex);
							});

							// Manual nav on content triggers image nav
							$contentSlider.on('click', '.owl-prev', () => {
								$imageSlider.trigger('prev.owl.carousel');
							});
							$contentSlider.on('click', '.owl-next', () => {
								$imageSlider.trigger('next.owl.carousel');
							});
							$contentSlider.on('click', '.owl-dot', function () {
								const dotIndex = rp$(this).index();
								$imageSlider.trigger('to.owl.carousel', [dotIndex, baseConfig.smartSpeed, true]);
							});

							// Pause autoplay on manual nav then resume
							$contentSlider.add($imageSlider).on('click', '.owl-prev, .owl-next, .owl-dot', () => {
								$imageSlider.trigger('stop.owl.autoplay');
								setTimeout(() => $imageSlider.trigger('play.owl.autoplay', [timeout]), timeout + 200);
							});
						});
					};

					// Height adjustment
					function updateContentHeight() {
						const slideContent = $contentSlider.find('.slide-content');
						const sliderHeight = slideContent.outerHeight(true);
						const slideContentArr = $contentSlider.find('.slide-content-wrap');
						const slideImageArr = $imageSlider.find('.slide-image-wrap');
						const allSlidersArr = [...slideContentArr, ...slideImageArr];
	
						rp$.each(allSlidersArr, function(idx, slide_content_ele) {
							rp$(slide_content_ele).innerHeight(sliderHeight).addClass('height-adjusted');
						});
						$imageSlider.trigger('stop.owl.autoplay');
						$contentSlider.trigger('stop.owl.autoplay');
						$imageSlider.trigger('to.owl.carousel', [0, baseConfig.smartSpeed, true]);
						$contentSlider.trigger('to.owl.carousel', [0, baseConfig.smartSpeed, true]);

					}
					updateContentHeight();
	
					window.onresize = debounce(updateContentHeight, 250);
				});
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
